/// <amd-module name="Reporting/Common/ICacheableQuery" />
import { IVssPageContext } from "VSS/Platform/Context";

/**
 * Expresses behavior of a query for which the configuration can be uniquely identified as a string and the query promise can be cached.
 * Guidance:
 *  -REST Queries can implement this contract, with help of generated REST clients.
 *  -ODATA Queries should derive from CachableAnalyticsQuery base class, which handles boilerplate implementation problems.
 */
export interface ICacheableQuery<T> {
    getKey(): string;
    runQuery(pageContext: IVssPageContext): Promise<T>;
}

/**
 * Opt-in contract for cacheable query implementations to be notified of cache hits.
 */
export interface ITrackCacheHits {
    onCacheHit(pageContext: IVssPageContext): void;
}
